/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../auth/auth';
import {
  calculateWorkerFRI,
  getClientsByWorkerId,
  getWorkerDefaults,
  getWorkersfrjobsPaginated
} from '../../api/apiCall';
import { useSearchParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { DataGrid } from '@mui/x-data-grid';
import { format } from 'date-fns';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  TextField,
} from "@mui/material";
import WorkerDefaults from './Modal/WorkerDefaults/WorkerDefaults';
import IndividualDefault from './Modal/IndividualDefault/IndividualDefault';
import { fieldsToCheck } from './utils';
import { Modal } from 'antd';
import GenerateExcel from './Modal/GenerateExcel/GenerateExcel';
import { toast } from 'react-toastify';

const FatigueUser = () => {
  const { state } = useAuth();
  const [searchParams] = useSearchParams();
  const [worker, setWorker] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [openIndividualDefaultModal, setOpenIndividualDefaultModal] = useState(false);
  const [openAllDefaults, setOpenAllDefaults] = useState(false);
  const [userJobId, setUserJobid] = useState('');
  const [defaults, setDefaults] = useState<any>({});
  const [individualDefault, setIndividualDefault] = useState(null);
  const [clients, setClients] = useState<any>([]);
  const [open, setOpen] = useState(false);

  const { register, handleSubmit, watch, control } = useForm<any>({
    defaultValues: {
      startWeek: searchParams.get('startWeek'),
      endWeek: searchParams.get('endWeek'),
      year: searchParams.get('year'),
      page: 0,
      itemsPerPage: 0,
      companyId: "",
    },
  });

  const getClients = async () => {
    const response = await getClientsByWorkerId(state.user?.token, searchParams.get('workerId'));
    if(response) {
      setClients(response);
    }
  }

  const watchFields = watch();

  const getDefaults = async () => {
    const response = await getWorkerDefaults(state.user?.token, searchParams.get('workerId'));
    setDefaults(response);
  }

    const handleCloseDefaultsModal = () => {
    getDefaults();
    setOpenAllDefaults(false);
    getWorkers(watchFields);
  }

  const handleCloseIndividualModal = () => {
    setUserJobid('');
    setOpenIndividualDefaultModal(false);
    getWorkers(watchFields);
  };

  const getWorkers = async (formData?: any) => {
    try {
      setLoading(true);
      const requestData = {
        userId: searchParams.get('workerId'),
        ...formData,
      };

      const response: any = await getWorkersfrjobsPaginated(state.user?.token, requestData);
      setWorker(response || []);
    } catch (error) {
      console.error('Error fetching worker data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const delayDebounce = setTimeout(() => {
      getWorkers(watchFields);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [watchFields.startWeek, watchFields.endWeek, watchFields.year, watchFields.companyId]);

  useEffect(() => {
    // getWorkers(watchFields);
    getClients();
    getDefaults();
  }, []);

  const calculatefatigue = async (formData: any) => {
    try {
      setLoading(true);
      const response = await calculateWorkerFRI(state.user?.token, {
        userId: searchParams.get('workerId'),
        ...formData,
      })

      if(!response.success) {
        toast.error(
          <div>
            {response.message}
            {Array.isArray(response.errors) && (
              <ul>
                {response.errors.map((line: any, i: any) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            )}
          </div>
        );
      }
    } catch (error) {
      console.error('Error fetching worker data:', error);
    } finally {
      getWorkers(watchFields);
      setLoading(false);
    }
  }

  const columns: any = [
    {
      field: 'fullName',
      headerName: 'Full Name',
      flex: 1,
      renderCell: (params: any) => (
        <span>{params.row.fullName}</span>
      ),
    },
    {
      field: 'pts',
      headerName: 'PTS',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'phoneNumber',
      headerName: 'Phone Number',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'whatsAppName',
      headerName: 'Team Name',
      flex: 1.4,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'jobDate',
      headerName: 'Date',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {format(new Date(params.row.jobDate || Date.now()), 'dd/MM/yyyy')}
        </div>
      ),
    },
    {
      field: 'endDayTime',
      headerName: 'Shift Time',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {format(new Date(params.row.startDayTime), 'HH:mm')} - {format(new Date(params.row.endDayTime), 'HH:mm')}
        </div>
      ),
    },
    {
      field: 'fatigueIndex',
      headerName: 'Fatigue Index',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const fatigue = params.row.fatigueIndex;

        const hour = format(params.row.startDayTime, 'HH');
        const shiftType = Number(hour) >= 6 && Number(hour) < 18 ? 'Day Shift' : 'Night Shift';

        if (fatigue === -1 || fatigue === null || fatigue === undefined) {
          return (
            <div style={{ color: '#333' }}>
              Not Calculated
            </div>
          );
        }

        const value = fatigue.toFixed(1);
        const isHigh = shiftType === 'Day Shift' ? fatigue > 35 : fatigue > 45;

        return (
          <div
            style={{
              fontWeight: 'bold',
              color: isHigh ? 'red' : 'green',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      field: 'riskIndex',
      headerName: 'Risk Index',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const risk = params.row.riskIndex;

        if (risk === -1 || risk === null || risk === undefined) {
          return (
            <div style={{ color: '#333' }}>
              Not Calculated
            </div>
          );
        }

        const value = risk.toFixed(2);
        const isHigh = value > 1.60;

        return (
          <div
            style={{
              fontWeight: 'bold',
              color: isHigh ? 'red' : 'green',
            }}
          >
            {value}
          </div>
        );
      },
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => {
        const hasDifference = fieldsToCheck.some(
          key => defaults[key] !== params.row[key]
        );
        return (
          <Button
            variant="contained"
            onClick={() => {
              setUserJobid(params.row.id);
              setIndividualDefault(params.row)
              setOpenIndividualDefaultModal(true);
            }}
            style={{
              boxShadow: "none",
              backgroundColor: "#6c757d",
              width: 110,
            }}
          >
            {hasDifference? 'Individual': 'Default'}
          </Button>
        )
      },
    },
  ];

  return (
    <>
      <div className="form-content">
        <TextField
          label="Start Week"
          type="number"
          size="small"
          {...register('startWeek')}
          style={{ width: '10%', margin: 10 }}
        />
        <TextField
          label="End Week"
          type="number"
          size="small"
          {...register('endWeek')}
          style={{ width: '10%', margin: 10 }}
        />
        <TextField
          label="Year"
          type="number"
          size="small"
          {...register('year')}
          style={{ width: '10%', margin: 10 }}
        />
        <Controller
          name="companyId"
          control={control}
          render={({ field }) => (
            <Autocomplete
              options={clients}
              getOptionLabel={(option: any) => option.companyName || ""}
              isOptionEqualToValue={(option: any, value: any) =>
                option.companyName === value?.companyName
              }
              value={field.value || null}
              onChange={(_, value) => field.onChange(value)}
              clearOnEscape
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client"
                  size="small"
                  sx={{ width: "210px", margin: 1.2 }}
                />
              )}
            />
          )}
        />
        <Button
          variant="contained"
          disabled={loading}
          onClick={handleSubmit(calculatefatigue)}
          style={{ height: 40, margin: 10, boxShadow: 'none', width: '10%', backgroundColor: "#1976d2", color: "white" }}
        >
          Calculate
        </Button>
        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          style={{ height: 40, margin: 10, boxShadow: 'none', width: '10%' }}
        >
          Generate Excel
        </Button>
        <Button
          variant="contained"
          onClick={() => setOpenAllDefaults(true)}
          style={{ height: 40, margin: 10, boxShadow: 'none', width: '10%' }}
        >
          Defaults
        </Button>
      </div>

      <Box sx={{ height: '800px', width: '75%', margin: '0 auto' }} mt={3}>
        <DataGrid
          rows={worker}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              fontSize: 15,
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
            },
          }}
        />
      </Box>
      <Dialog
        open={openAllDefaults}
        onClose={() => setOpenAllDefaults(false)}
        maxWidth="lg"
        fullWidth
        scroll="paper"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            backgroundColor: "#fafafa",
            maxHeight: "90vh",
          },
        }}
      >
        <WorkerDefaults workerId={searchParams.get('workerId')} defaults={defaults} handleClose={handleCloseDefaultsModal} />
      </Dialog>
      <Dialog
        open={openIndividualDefaultModal}
        onClose={() => {
          setOpenIndividualDefaultModal(false);
          setUserJobid('');
        }}
        maxWidth="lg"
        fullWidth
        scroll="paper"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            backgroundColor: "#fafafa",
            maxHeight: "90vh",
          },
        }}
      >
        <IndividualDefault userJobId={userJobId} workerId={searchParams.get('workerId')} individualDefault={individualDefault} defaults={defaults} handleClose={handleCloseIndividualModal}/>
      </Dialog>
      <Modal
        title={`Generate Excel`}
        onCancel={() => setOpen(false)}
        open={open}
        destroyOnClose
        footer={[]}>
          <GenerateExcel
            setOpen={setOpen}
            clients={clients}
            workerId={searchParams.get('workerId')}
            companyId={watchFields.companyId}
          />
      </Modal>
    </>
  );
};

export default FatigueUser;
